import { Database } from "#/supabase/supabaseSchema";
import { MessageFileStore } from "./fileStore.type";
import { UserRow } from "./user.type";

export enum MessageRole {
  USER = "user",
  ASSISTANT = "assistant",
}

export type CreateMessageBody = {
  content: string;
  fileStoreIds?: string[];
};
export type MessageRow = Database["public"]["Tables"]["message"]["Row"] & {
  message_file_store: MessageFileStore[];
  user: Partial<UserRow>;
  // Support either a single feedback row or an array, depending on API shape
  message_feedback?: MessageFeedback | MessageFeedback[];
};

export type MessageFeedback = {
  id: string;
  message_id: string;
  user_id: string;
  is_positive: boolean;
  flagged?: boolean | null;
  created_at: string | null;
  updated_at: string | null;
};

export type MessageWithPagination = {
  messages: MessageRow[];
  totalCount: number;
  nextPage: number | null;
};

export type MessagesWithPagination = {
  messages: MessageRow[];
  totalCount: number;
  nextPage: number | null;
};

export type AdminUserWithMessages = {
  id: string;
  first_name: string | null;
  last_name: string | null;
};
